<!-- Loading animation -->
<cv-loader *ngIf="showLoader"></cv-loader>

<!-- Header -->
<div class="modal-header">
    <!-- Title -->
    <p class="h7" cvLocalizedText langSection="Template_List_Modal" langKey="Select_Template">Select Template</p>
    <!-- X button -->
    <button type="button" (click)="closeModal();" class="modal-close icon-btn fill-valyrianSteel fill-hover-whaleTail">
        <svg class="icon-16">
            <use href="../App_Themes/clearview-default/icons/utility/close.svg#close"></use>
        </svg>
    </button>
</div>

<!-- Body -->
<div class="modal-body cxone-template-list-body">
    <div class="managementBody mt-4">
        <div class="d-flex flex-grow-1" style="min-height: 0;">
            <div class="d-flex flex-column col p-0">
                <div class="d-flex mt-3 pb-3 mb-1 align-items-center dashboardHeader" role="status" aria-live="polite" id="dashboardCount">
                    <!-- Templates count -->
                    <div class="mr-1 ml-3" style="min-width: 100px; max-width: max-content" *ngIf="getNumGridRows() !== 1" tabindex="0">
                        {{ getNumGridRows() + ' ' + getLocaleText('Templates', 'Templates') }}
                    </div>
                    <div class="mr-1 ml-3" style="min-width: 100px; max-width: max-content" *ngIf="getNumGridRows() === 1" tabindex="0">
                        {{ getNumGridRows() + ' ' + getLocaleText('Template', 'Template') }}
                    </div>
                    <!-- Search bar -->
                    <div class="cxone-live-search">
                        <cxone-text-input type="search"
                                          autocomplete="off"
                                          class="cxone-dashboard-search"
                                          [placeholder]="getLocaleText('Search_Bar_Placeholder', 'Start typing to find templates')"
                                          [(ngModel)]="this.filterValue"
                                          (ngModelChangeDebounced)="filterValue"
                                          [ngModelChangeDebounceTime]="500"
                                          (keyup)="applyFilter()">
                        </cxone-text-input>
                        <i class="icon-search" [hidden]="filterValue.length !== 0">
                            <svg class="icon-18 fill-iconDefault-noHover search-wrapper">
                                <use href="../App_Themes/CXone/icons/search.svg#search"></use>
                            </svg>
                        </i>
                        <i class="icon-search" [hidden]="filterValue.length === 0" (click)="clearFilter()">
                            <svg class="icon-18 fill-iconDefault-noHover close-wrapper">
                                <use href="../App_Themes/CXone/icons/close.svg#close"></use>
                            </svg>
                        </i>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12 cxoneDashboardsGrid">
                        <ag-grid-angular #templateListModalGrid *ngIf="getGridOptions() !== null" class="ag-theme-balham flex-fill" [gridOptions]="getGridOptions()">
                        </ag-grid-angular>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<!-- Footer -->
<div class="modal-footer">
    <!-- Cancel button -->
    <button type="button" class="btn modal-footer-btn btn-secondary" (click)="closeModal()" cvLocalizedText langSection="Template_List_Modal" langKey="Cancel">Cancel</button>
    <!-- Select button -->
    <button type="button" class="btn btn-primary modal-footer-btn cxone-btn" (click)="selectButtonClicked()" [disabled]="isTemplateSelected()">
        <span cvLocalizedText langSection="Template_List_Modal" langKey="Select">Select</span>
    </button>
</div>
